import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const Calendar =({classProps, dataSetProps, startDateProps, changeDateFunc, refProps}) => {

        return (
            <DatePicker
                className={classProps}
                data-name={dataSetProps}
                ref={refProps}
                selected={startDateProps}
                onChange={changeDateFunc}
                dateFormat="dd.MM.YYY"
                maxDate={new Date()}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
        );
}

export default Calendar;
